/**
 * Datele de livrare ale unei cereri de marfă trimise prin curier — și ce înseamnă „complete".
 *
 * Madalin, 16.10.2026: „să necesite detalii exacte, persoană de contact, număr de telefon, adresă
 * completă, mail — tot ce e important pentru un AWB CORECT, nu vrem să ne trezim cu AWB-uri
 * generate greșit". Un AWB cu adresa greșită se plătește oricum.
 *
 * Aceeași regulă e folosită de formular (ca să arate ce lipsește) și de server (care refuză
 * trimiterea cererii). De aceea stă aici, nu în două locuri care ar ajunge să difere.
 *
 * Județul și localitatea NU se verifică aici: se aleg din lista FAN Courier, iar existența lor în
 * listă o verifică serverul (`nomenclatorFan`). Aici e doar forma câmpurilor.
 */
import { numarNationalRo } from './telefon.js';
/** Numărul străzii când adresa chiar n-are unul. Ales explicit, nu dedus dintr-un câmp gol. */
export const FARA_NUMAR = 'FN';
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
/**
 * Ce lipsește sau e greșit, pe câmpuri. Gol = datele sunt complete.
 *
 * Mesajele sunt pentru omul din fața formularului: spun ce să scrie, nu ce regulă a picat.
 */
export function verificaLivrare(l) {
    const e = {};
    const t = (v) => (v ?? '').trim();
    if (!t(l?.nume))
        e.nume = 'Scrie cui îi pleacă coletul.';
    const contact = t(l?.contact);
    if (!contact)
        e.contact = 'Scrie persoana de contact.';
    else if (contact.split(/\s+/).length < 2)
        e.contact = 'Scrie numele și prenumele.';
    if (!numarNationalRo(l?.telefon))
        e.telefon = 'Un număr românesc de 10 cifre, de exemplu 0722 123 456.';
    if (!EMAIL.test(t(l?.email)))
        e.email = 'O adresă de email validă — FAN trimite pe ea anunțul de livrare.';
    if (!t(l?.judet))
        e.judet = 'Alege județul.';
    if (!t(l?.localitate))
        e.localitate = 'Alege localitatea.';
    if (!t(l?.strada))
        e.strada = 'Scrie strada.';
    if (!t(l?.numar))
        e.numar = `Scrie numărul, sau bifează „fără număr".`;
    if (!/^\d{6}$/.test(t(l?.codPostal)))
        e.codPostal = 'Codul poștal are 6 cifre.';
    return e;
}
/** Forma salvată: spații tăiate, telefonul în forma națională, gol → null. */
export function normalizeazaLivrare(l) {
    const t = (v) => v?.trim() || null;
    return {
        nume: t(l?.nume),
        contact: t(l?.contact),
        telefon: numarNationalRo(l?.telefon) ?? t(l?.telefon),
        email: t(l?.email)?.toLowerCase() ?? null,
        judet: t(l?.judet),
        localitate: t(l?.localitate),
        strada: t(l?.strada),
        numar: t(l?.numar),
        bloc: t(l?.bloc),
        scara: t(l?.scara),
        etaj: t(l?.etaj),
        apartament: t(l?.apartament),
        codPostal: t(l?.codPostal),
    };
}
//# sourceMappingURL=livrare.js.map